import config from "@/config"
import http from "@/utils/request"


export default {
    getShopList: {
        url: `${config.API_URL}/api/app/common-lookup/user-auth-shops`,
        name: "获取店铺列表",
        get: async function () {
            return await http.get(this.url);
        }
    },
    getCaseBusinessGroupByShopId: {
        url: `${config.API_URL}/api/app/amazon-case-business-group/by-shop-id-list/`,
        name: "根据店铺ID获取第一层的组别列表",
        get: async function (params) {
            return await http.get(this.url + params);
        }
    },
    getListByParentIdAndShop: {
        url: `${config.API_URL}/api/app/amazon-case-business-group/by-parent-id-and-shop`,
        name: "根据店铺ID获取第一层的组别列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    create: {
        url: `${config.API_URL}/api/app/amazon-case`,
        name: "创建工单",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    getPageList: {
        url: `${config.API_URL}/api/app/amazon-case/page-list`,
        name: "获取工单分页数据",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    cancelCase: {
        url: `${config.API_URL}/api/app/amazon-case/cancel`,
        name: "工单取消",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    getAmazonContactListByCaseId: {
        url: `${config.API_URL}/api/app/amazon-case-contact/by-case-id/`,
        name: "根据CaseId获取此工单对话列表",
        get: async function (params) {
            return await http.get(this.url + params);
        }
    },
    createAmazonContact: {
        url: `${config.API_URL}/api/app/amazon-case-contact`,
        name: "回复新消息",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    }

}
